import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vialfa-admin-token", data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-navy flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md bg-navy-800 border border-navy-600 p-10"
      >
        <div className="flex flex-col items-center mb-10">
          <img src="/assets/logo-light.png" alt="VIALFA Handyman Services" className="h-20 w-auto" data-testid="admin-login-logo" />
          <span className="mt-3 text-xs font-bold uppercase tracking-widest text-offwhite/40">Admin</span>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.2em] text-offwhite/50 mb-2">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-navy border border-navy-600 px-4 py-3 text-offwhite focus:outline-none focus:border-orange transition-colors duration-200"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.2em] text-offwhite/50 mb-2">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-navy border border-navy-600 px-4 py-3 text-offwhite focus:outline-none focus:border-orange transition-colors duration-200"
            />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-bright disabled:opacity-60 text-white font-bold px-8 py-4 text-sm uppercase tracking-widest transition-colors duration-200"
          >
            {loading ? "Signing in…" : "Sign In"} <LogIn size={16} />
          </button>
        </form>
      </motion.div>
    </div>
  );
}
